import { render, staticRenderFns } from "./EmailPreferences.vue?vue&type=template&id=e49d8746"
import script from "./EmailPreferences.vue?vue&type=script&lang=js"
export * from "./EmailPreferences.vue?vue&type=script&lang=js"
import style0 from "./EmailPreferences.vue?vue&type=style&index=0&id=e49d8746&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports